import { Link } from 'react-router-dom';
import styled from 'styled-components';
import colors from '@theme/colors';

export const StyledLink = styled(Link)`
  color: ${colors.LINK};
`;



// WEBPACK FOOTER //
// ./components/pages/NoPermission/layout.js